import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAutoSelect]'
})
export class AutoSelectDirective {

  constructor(
    private hostElRef: ElementRef
  ) { }

  @HostListener('click')select () {
    this.hostElRef.nativeElement.focus();
    this.hostElRef.nativeElement.select();
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/auto-select.directive.ts